import type { ApiProfileDto, UpdateProfileDto, UserInfo } from '../../api/types';
import type { ProfileInfoForm } from '../schemas';
import type { Profile, SpaceUserInfo } from '../types';

export const mapApiProfileToProfile = (dto: ApiProfileDto): Profile => ({
	email: dto.mail ?? '',
	fullName: dto.full_name ?? '',
	role: dto.role ?? '',
	language: dto.language ?? '',
	avatarUrl: dto.avatar || undefined,
});

export const mapProfileFormToDto = (form: ProfileInfoForm): UpdateProfileDto => ({
	mail: form.email,
	full_name: form.fullName,
	locale: form.locale,
});

export const mapUserInfoFromApi = (apiData: UserInfo): SpaceUserInfo => ({
	userName: apiData.user_name,
	currency: apiData.exchange_value,
	currencySymbol: apiData.exchange_symbol,
	language: apiData.language,
	languageAbbreviation: apiData.language_abbreviation,
	role: apiData.role,
	isDelegation: apiData.is_delegation,
	userId: apiData.id_user.toString(),
	tokenName: apiData.token_name,
	isManager: apiData.is_manager,
	companyId: apiData.company_id,
	companyName: apiData.company_name,
});
